import { Game } from "@/models/Game";

export type Set = 1 | 2 | 3 | 4 | 5;
type Side = "Home" | "Away";
export type ScoreObject = Pick<
  Game,
  | "set1HomeScore"
  | "set1AwayScore"
  | "set2HomeScore"
  | "set2AwayScore"
  | "set3HomeScore"
  | "set3AwayScore"
  | "set4HomeScore"
  | "set4AwayScore"
  | "set5HomeScore"
  | "set5AwayScore"
>;
type ScoreField = keyof ScoreObject;

export const Sets: Set[] = [1, 2, 3, 4, 5];

function scoreField(set: Set, side: Side): ScoreField {
  return `set${set}${side}Score`;
}

export function scoreOrDefault<T>(
  game: ScoreObject,
  set: Set,
  side: Side,
  def: T
): number | T {
  const s = game[scoreField(set, side)];
  return typeof s === "number" ? s : def;
}

export function scoreOrDash(game: ScoreObject, set: Set, side: Side) {
  return scoreOrDefault(game, set, side, "-");
}

export function winnerByScore(game: ScoreObject, set: Set): Side | undefined {
  const s1 = game[scoreField(set, "Home")];
  const s2 = game[scoreField(set, "Away")];

  return winnerByPoints(s1, s2);
}

export function winnerByPoints(
  s1: number | null | undefined,
  s2: number | null | undefined
): Side | undefined {
  if (typeof s1 === "number" && typeof s2 === "number") {
    if (s1 - s2 >= 2 && s1 >= 11) {
      return "Home";
    } else if (s2 - s1 >= 2 && s2 >= 11) {
      return "Away";
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
}

//
// export function smallerThen(s1: number|null|undefined, s2: number|null|undefined) {
//   if(typeof s1 === 'number' && typeof s2 === 'number') {
//     return s1 < s2
//   } else {
//     return false
//   }
// }
//
// export function greaterThen(s1: number|null|undefined, s2: number|null|undefined) {
//   if(typeof s1 === 'number' && typeof s2 === 'number') {
//     return s1 > s2
//   } else {
//     return false
//   }
// }
